enum Permissions {
  //region Customer permissions (100-199)
  CustomerCreate = 101,
  CustomerUpdate = 102,
  CustomerDeleteRestore = 103,
  CustomerView = 104,

  //endregion

  //region Client permissions (200-299)
  ClientCreate = 205,
  ClientUpdate = 206,
  ClientDeleteRestore = 207,
  ClientView = 208,
  ClientViewSelf = 209,
  ClientUpdateSelf = 210,
  ClientFeatureView = 211,
  ClientFeatureCreateModify = 212,
  ClientFeatureDeleteRestore = 213,
  //endregion

  //region User permissions (300-399)
  UserPermissionView = 300,
  UserViewSelf = 301,
  UserUpdateSelf = 302,
  UserCreate = 309,
  UserUpdate = 310,
  UserDeleteRestore = 311,
  UserView = 312,

  //endregion

  //region Location permissions (400 -499)
  LocationCreate = 413,
  LocationUpdate = 414,
  LocationDeleteRestore = 415,
  LocationView = 416,
  //endregion

  //region Asset permissions (500 -599)
  AssetTypeView = 500,
  AssetTypeCreateModify = 501,
  AssetTypeDeleteRestore = 502,

  AssetOptionView = 505,
  AssetOptionCreateModify = 506,
  AssetOptionDeleteRestore = 507,

  AssetCreate = 517,
  AssetUpdate = 518,
  AssetDeleteRestore = 519,
  AssetView = 520,

  AssetRateView = 530,
  AssetRateCreateModify = 531,
  AssetRateDeleteRestore = 532,

  //endregion

  //region Insurance provider permissions (600 -699)
  InsuranceProviderView = 621,
  InsuranceProviderCreateModify = 622,
  InsuranceProviderDeleteRestore = 623,
  //endregion

  //region asset make permissions (700 -799)
  AssetMakeView = 724,
  AssetMakeCreateModify = 725,
  AssetMakeDeleteRestore = 726,
  //endregion

  //region asset model permissions (800 -899)
  AssetModelView = 827,
  AssetModelCreateModify = 828,
  AssetModelDeleteRestore = 829,
  //endregion

  //region Geo data permissions (900 - 999)
  CountryView = 930,
  StateView = 931,
  //endregion

  //region Booking permissions (1000 - 1049)
  BookingView = 1000,
  BookingCreateModify = 1001,
  BookingDeleteRestore = 1002,
  //endregion

  //region Booking permissions (1050 - 1100)
  ContractView = 1050,
  ContractCreateModify = 1051,
  ContractDeleteRestore = 1052,
  //endregion

  //region asset option map permission (1100 - 1199)
  AssetOptionMapView = 1103,
  AssetOptionMapCreate = 1104,
  AssetOptionMapDelete = 1105,
  //endregion

  //region asset document permission (1200 -1299
  AssetDocumentView = 1206,
  AssetDocumentCreate = 1207,
  AssetDocumentDelete = 1208,
  //endregion

  //region dashboard permission (1300 - 1399)
  DashboardView = 1300,
  DashboardModify = 1301,
  //endregion

  //region customer document permission (1400 -1499
  CustomerDocumentView = 1402,
  CustomerDocumentCreate = 1403,
  CustomerDocumentDelete = 1404,
  //endregion

  //region damage permission (1500 -1599
  DamageView = 1505,
  DamageCreateModify = 1506,
  DamageDelete = 1507,
  //endregion

  //region damage type permission (1600 -1699
  DamageTypeView = 1608,
  DamageTypeCreate = 1609,
  //endregion

  //region damage Image permission (1700 -1799
  DamageDocumentView = 1701,
  DamageDocumentCreateModify = 1702,
  DamageDocumentDelete = 1703,
  //endregion

  //region Booking Calandar permission (1800 -1899
  VehicleScheduleView = 1801,
  //endregion

  //region Invoice permissions (1900 -1999)
  InvoiceView = 1900,
  InvoiceCreateModify = 1901,
  InvoiceDeleteRestore = 1902,
  //endregion

  //region Expense permissions (2000 -2099)
  ExpenseView = 2000,
  ExpenseCreateModify = 2003,
  ExpenseDeleteRestore = 2004,
  //endregion

  //region Vendor permissions (2100 -2199)
  VendorView = 2101,
  VendorCreateModify = 2102,
  VendorDeleteRestore = 2103,
  //endregion

  //region Account permissions (3000 -3099)
  GLAccountView = 3000,
  GLAccountCreateModify = 3001,
  GLAccountDeleteRestore = 3002,
  //endregion

  //region Todo permissions (3000 -3099)
  TodoView = 3200,
  TodoCreateModify = 3201,
  TodoDeleteRestore = 3202,
  //endregion

  //region Terms And Coondition permissions (3300 -3399)
  TermsAndConditionView = 3301,
  TermsAndConditionCreateModify = 3302,
  TermsAndConditionRestore = 3303,
  //endregion
}

export default Permissions;
